import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { ImageGallery } from 'elements/minute/sidebar/sidebarComponents/complex/ImageGallery';
import { SidebarSectionRow } from 'elements/minute/sidebar/sidebarSection/SidebarSectionRow';
import { useUploadImage } from 'libs/hooks/io/useUploadImage';
import { EImageCategories } from 'libs/images/ImageGalleryData';
import { EUploadResolution } from 'libs/utils/logic/operations/fileOperations';
import { useContext, useEffect, useState } from 'react';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    title?: string;
    onSelected?: (imageUrl: string) => void;
    selectedImageUrl: string | null;
    dragAndDropEnabled?: boolean;
    initialRowsVisible?: number;
    galleryType: 'image' | 'icon';

    hideSearch?: boolean;
    hideCategoryFilter?: boolean;
    hideOpenModal?: boolean;
    additionalImages?: string[];
    initialCategory?: EImageCategories;
    highlightedCategoryIds?: string[];
}

export const ImageGalleriesImageContent = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);
    const { uploaded, setFiles } = useUploadImage(
        [EUploadResolution.SMALL, EUploadResolution.BIG],
        ctxEdit.map?.worldMapId
    );
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        if (uploaded?.data?.imageUrls) {
            const iconUrl = uploaded?.data?.imageUrls?.[EUploadResolution.SMALL];
            const imageUrl = uploaded?.data?.imageUrls?.[EUploadResolution.BIG];
            props.onSelected(props.galleryType === 'icon' ? iconUrl : imageUrl);
            setUploading(false);

            ctxEdit.updateMap({
                iconGallery: [iconUrl, ...ctxEdit.map.iconGallery],
                imageGallery: [imageUrl, ...ctxEdit.map.imageGallery]
            });
        }
    }, [uploaded]);

    return (
        <S_ImageGalleriesImageContent className={props.className}>
            <SidebarSectionRow title={props.title ?? Localization.YOUR_IMAGE}>
                <label>
                    <S_InputFile
                        type="file"
                        accept="image/x-png,image/png,image/gif,image/jpeg,image/jpg,image/heic,image/heif,image/svg+xml,.heic;capture=camera"
                        onChange={(e) => {
                            setUploading(true);
                            setFiles(Array.from(e.target['files']));
                        }}
                    />
                    <ActionButton
                        text={
                            uploading ? Localization.UPLOADING + '...' : Localization.UPLOAD_ACTION
                        }
                        icon={{ iconName: 'upload' }}
                        disabled={uploading}
                    />
                </label>
            </SidebarSectionRow>
            <ImageGallery
                additionalImages={(props.additionalImages ?? []).concat(
                    props.galleryType === 'icon'
                        ? ctxEdit.map.iconGallery
                        : ctxEdit.map.imageGallery
                )}
                dragAndDropEnabled={props.dragAndDropEnabled}
                selectedImageUrl={props.selectedImageUrl}
                initialRowsVisible={props.initialRowsVisible}
                onSelected={props.onSelected}
                hideSearch={props.hideSearch}
                hideCategoryFilter={props.hideCategoryFilter}
                hideOpenModal={props.hideOpenModal}
                initialCategory={props.initialCategory}
                highlightedCategoryIds={props.highlightedCategoryIds}
            />
        </S_ImageGalleriesImageContent>
    );
};

const S_ImageGalleriesImageContent = styled.div``;

const S_InputFile = styled.input`
    display: none;
`;
